export enum AssessmentAnnulTypeEnum {
  Question = 1,
  Answer = 2,
}
